module.exports = __webpack_public_path__ + "img/ic_isologo.b40f404f.png";